/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Support_DescriptionInputs */



/**
* | output |
* | --- |
* | "Donate, share, or shop through our links" |
*
* @param {Layout_Header_Support_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_support_description = /** @type {((inputs?: Layout_Header_Support_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Support_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Spenden, teilen oder über unsere Links einkaufen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Faites un don, partagez ou achetez via nos liens")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("捐赠、分享，或通过我们的链接购物")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("贊助、分享，或透過我們的連結購物")
	if (locale === "ko") return /** @type {LocalizedString} */ ("후원하거나, 공유하거나, 링크를 통해 구매하세요")
	return /** @type {LocalizedString} */ ("Donate, share, or shop through our links")
});